import { render, staticRenderFns } from "./InventoryExpenseFormList.vue?vue&type=template&id=aba05388&"
import script from "./InventoryExpenseFormList.vue?vue&type=script&lang=js&"
export * from "./InventoryExpenseFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports